<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-edit">

    <vx-card >

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs class="tab-action-btn-fill-conatiner">
          <vs-tab :label="$t('MODULES.moduleCreation')" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <module-add-tab class="mt-4" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import ModuleAddTab     from './ModuleAddTab.vue'

// Store Module
// import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    ModuleAddTab
  },
  data () {
    return {

    }
  },
  mounted () {
    document.title = `${document.title.split(' | ')[0]  } | Módulos`
  },
  methods: {
  //   getRoles() {
  //     fetch(this.$store.state.auth.api_url, {
  //       method: 'POST', headers: {"Content-Type": "application/json"},
  //       body: JSON.stringify({
  //         command: 'get_application_roles_list',
  //         parameters: {
  //           application_token: this.$store.state.auth.app_token,
  //           session_token: this.$store.state.auth.token
  //         }
  //       })
  //     })
  //       .then(async (response) => {
  //         if (response.status === 200) {
  //           await response.json().then(async (response) => {
  //             this.$store.commit('userManagement/setRolesList', response.payload)
  //           })
  //         } else if (response.status == 401) {
  //           setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
  //           store.dispatch('auth/signOut')
  //         }
  //       })
  //       .catch((error) => {
  //         reject(error)
  //       })
  //   },
  // },
    created () {

    }
  }
}

</script>
